import { usePathname } from 'next/navigation';
import { NormalizedLocale } from '@/enums/Locale';

export default function useLocale() {
	const pathname = usePathname();
	const localeFromUrl = pathname.split('/')[1] as NormalizedLocale;

	return Object.values(NormalizedLocale).includes(localeFromUrl) ? localeFromUrl : NormalizedLocale.EN;
}
